// I discorsi di PopTown (artboard 56): ogni coppia di ruoli parla del proprio lavoro, a turno, e
// l'altro risponde nel merito. La chiave è la coppia di ruoli in ordine alfabetico; 0 è il primo
// della coppia, 1 il secondo. Una conversazione non si ripete finché ce ne sono altre.

/** [chi parla: 0 = primo ruolo della chiave, 1 = secondo, battuta] */
export type Line = [0 | 1, string];

export const TALKS: Record<string, Line[][]> = {
  'project-manager|team-lead': [
    [
      [0, 'Come siamo messi con lo sprint?'],
      [1, 'Otto ticket chiusi, due aperti'],
      [0, 'Quelli aperti sono bloccanti?'],
      [1, 'Uno sì, aspetta la QA'],
      [0, 'Lo segnalo nella riunione delle 10'],
      [1, 'Perfetto, domani facciamo la demo'],
    ],
    [
      [0, 'Il cliente vuole anticipare il rilascio'],
      [1, 'Di quanto?'],
      [0, 'Una settimana'],
      [1, 'Serve un pop in più sul backend'],
      [0, 'Te lo trovo entro oggi'],
      [1, 'Allora ce la facciamo'],
    ],
    [
      [1, 'Ho rivisto la roadmap del trimestre'],
      [0, 'Cosa è cambiato?'],
      [1, 'Ho spostato la migrazione a dicembre'],
      [0, 'Rischi?'],
      [1, 'Pochi, i test sono pronti'],
      [0, 'Mandamela, la porto al cliente'],
    ],
  ],
  'ux-ui|web-designer': [
    [
      [0, 'Questo bottone è troppo piccolo'],
      [1, 'Quanto lo vuoi?'],
      [0, 'Almeno 44 pixel'],
      [1, 'E il contrasto del testo?'],
      [0, 'Quattro e mezzo a uno, minimo'],
      [1, 'Lo misuro nei due temi'],
    ],
    [
      [1, 'Ho una palette nuova per la home'],
      [0, 'Fammela vedere in tema chiaro'],
      [1, 'Regge anche lì, ho controllato'],
      [0, 'E gli stati di errore?'],
      [1, 'Corallo scuro, si legge bene'],
      [0, 'Approvata!'],
    ],
    [
      [0, 'Domani test con cinque utenti'],
      [1, 'Preparo il prototipo cliccabile'],
      [0, 'Mettici il flusso del login'],
      [1, 'Con la passkey?'],
      [0, 'Sì, vediamo se la trovano'],
      [1, 'Stasera è pronto'],
    ],
  ],
  'analyst|data-scientist': [
    [
      [0, 'I dati di ottobre sono pronti'],
      [1, 'Puliti?'],
      [0, 'Quasi, mancano tre giorni'],
      [1, 'Li interpolo io'],
      [0, 'Occhio al picco del 12'],
      [1, 'Lo tratto come anomalia'],
    ],
    [
      [1, 'Il modello ora è al 92 per cento'],
      [0, 'Sul campione nuovo?'],
      [1, 'Sì, misurato due volte'],
      [0, 'E sui casi rari?'],
      [1, "Lì scende all'80"],
      [0, 'Facciamo un report onesto'],
    ],
    [
      [0, 'Il grafico delle vendite non torna'],
      [1, 'Che asse usi?'],
      [0, 'Lineare'],
      [1, 'Prova in scala logaritmica'],
      [0, 'Ah, ecco la crescita!'],
      [1, 'Visto? Era lì'],
    ],
  ],
  'developer|qa': [
    [
      [0, 'Ho chiuso la feature del calendario'],
      [1, 'La provo subito'],
      [1, 'Un test è rosso'],
      [0, 'Quale?'],
      [1, 'Il fuso orario di novembre'],
      [0, 'Lo sistemo e ti ripasso la build'],
    ],
    [
      [1, 'Il gate è tutto verde'],
      [0, 'Anche gli e2e?'],
      [1, 'Sì, quattro minuti in tutto'],
      [0, 'Allora si rilascia'],
      [1, 'Vai, io controllo la produzione'],
    ],
  ],
  'developer|devops': [
    [
      [0, 'La build ci mette troppo'],
      [1, 'Quanto?'],
      [0, 'Dodici minuti'],
      [1, 'Metto la cache delle dipendenze'],
      [0, 'Quanto guadagniamo?'],
      [1, 'Almeno metà'],
    ],
    [
      [1, 'Deploy riuscito'],
      [0, 'Quanti secondi di fermo?'],
      [1, 'Quattro'],
      [0, 'E i container?'],
      [1, 'Ricreati solo api e worker'],
      [0, 'Ottimo lavoro'],
    ],
  ],
  'developer|reviewer': [
    [
      [0, 'Mi guardi la PR?'],
      [1, 'Due commenti e va'],
      [0, 'Quali?'],
      [1, 'Un nome poco chiaro e un test che manca'],
      [0, 'Li sistemo ora'],
      [1, 'Poi approvo'],
    ],
    [
      [1, 'Questa funzione fa troppe cose'],
      [0, 'La divido in due?'],
      [1, 'Sì, e togli il duplicato'],
      [0, 'Fatto, ripassa quando vuoi'],
    ],
  ],
  'developer|team-lead': [
    [
      [1, 'Come va la migrazione?'],
      [0, 'Il database è passato'],
      [1, 'E i dati?'],
      [0, 'Contati prima e dopo, tornano'],
      [1, 'Bene, scrivilo nel ticket'],
    ],
  ],
  'developer|web-designer': [
    [
      [1, 'Ti ho mandato le icone nuove'],
      [0, 'In SVG?'],
      [1, 'Sì, con il colore dai token'],
      [0, 'Così il tema scuro funziona'],
      [1, 'Esatto'],
    ],
  ],
  'mail-clerk|notifier': [
    [
      [0, 'Posta urgente per il PM'],
      [1, 'Gli mando una notifica'],
      [0, 'Con priorità alta'],
      [1, 'Push con suono?'],
      [0, 'Sì, è il cliente'],
      [1, 'Inviata!'],
    ],
    [
      [1, 'Quante email oggi?'],
      [0, 'Trentadue, tutte smistate'],
      [1, 'Qualcuna sospetta?'],
      [0, 'Una con testo nascosto'],
      [1, 'Filtrata?'],
      [0, "Sì, il filtro l'ha bloccata"],
    ],
  ],
  'mail-clerk|project-manager': [
    [
      [0, "C'è una risposta del cliente"],
      [1, 'Buone notizie?'],
      [0, 'Approvano il preventivo'],
      [1, 'Fantastico, avviso il team'],
    ],
  ],
  'researcher|writer': [
    [
      [0, 'Ho trovato le fonti per il report'],
      [1, 'Quante?'],
      [0, 'Sette, tutte verificate'],
      [1, 'Me le giri?'],
      [0, 'Già nella cartella condivisa'],
      [1, 'Stasera scrivo la bozza'],
    ],
    [
      [1, 'La bozza è pronta'],
      [0, 'Quanto è lunga?'],
      [1, 'Due pagine'],
      [0, 'Le cifre sono citate?'],
      [1, 'Tutte con la fonte'],
      [0, 'Allora la rileggo subito'],
    ],
  ],
  'analyst|researcher': [
    [
      [1, 'Ti servono dati sul mercato?'],
      [0, 'Sì, gli ultimi tre anni'],
      [1, 'Ho uno studio recente'],
      [0, 'Con la metodologia?'],
      [1, 'Spiegata bene, te lo mando'],
    ],
  ],
  'data-scientist|developer': [
    [
      [0, 'Il modello è pronto per la produzione'],
      [1, 'Quanto pesa?'],
      [0, 'Duecento mega'],
      [1, 'Lo mettiamo dietro una API'],
      [0, 'Con la cache delle risposte'],
      [1, 'Domani lo colleghiamo'],
    ],
  ],
  'devops|notifier': [
    [
      [0, 'Se il disco supera il 90 mi avvisi?'],
      [1, 'Certo, con una push'],
      [0, 'Solo a me, di notte'],
      [1, 'Silenziosa fino alle 8'],
      [0, 'Perfetto'],
    ],
  ],
  'qa|reviewer': [
    [
      [0, 'Questo cambio non ha test'],
      [1, "L'avevo notato anch'io"],
      [0, 'Chiedo di aggiungerlo?'],
      [1, 'Sì, un test di regressione'],
      [0, 'Lo scrivo nella PR'],
    ],
  ],
  'project-manager|qa': [
    [
      [0, 'Siamo pronti al rilascio?'],
      [1, 'Manca un ultimo giro'],
      [0, 'Quanto ci vuole?'],
      [1, "Mezz'ora"],
      [0, 'Aspetto te, poi si va'],
    ],
  ],
  'analyst|project-manager': [
    [
      [1, 'Mi serve il report per il cliente'],
      [0, 'Te lo preparo con tre grafici'],
      [1, 'Semplici, mi raccomando'],
      [0, 'Una pagina, niente gergo'],
      [1, 'Grazie!'],
    ],
  ],
  'ux-ui|writer': [
    [
      [1, "Questo messaggio d'errore è freddo"],
      [0, 'Riscrivilo più umano'],
      [1, 'Dice cosa fare dopo'],
      [0, 'Esatto, e niente codici'],
      [1, 'Te lo mando tra poco'],
    ],
  ],
};

/** due chiacchiere fra pop che non lavorano insieme */
export const SMALL: Line[][] = [
  [
    [0, 'Ciao!'],
    [1, 'Ciao, come va la giornata?'],
    [0, 'Piena, ma bella'],
    [1, 'Anche la mia'],
  ],
  [
    [0, 'Che bella serata'],
    [1, 'Si vede il mare dal ponte'],
    [0, 'Dopo ci faccio un giro'],
  ],
  [
    [0, 'Un caffè al bar?'],
    [1, 'Dopo la riunione volentieri'],
    [0, 'Ti aspetto lì'],
  ],
  [
    [1, 'Hai visto i lampioni nuovi?'],
    [0, 'Fanno una luce bellissima'],
    [1, 'Li ha scelti il web designer'],
  ],
];
